import setFilterQuery from "@iewcasia/Store/Handlers/Blog/SetFilterQuery";
import { CustomState } from "@iewcasia/Store/Reducers";
import { initialBlogState } from "@iewcasia/Store/State/Blog/BlogListState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Pagination, PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { ThemeProps, withTheme } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (customState: CustomState) => {
    const pagination = customState.blogList.pagination;

    return { pagination };
};

const mapDispatchToProps = {
    setFilterQuery,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme>;

export interface BlogListPaginationStyles {
    wrapper?: InjectableCss;
    pagination?: PaginationPresentationProps;
}

export const blogListPaginationStyles: BlogListPaginationStyles = {};

const styles = blogListPaginationStyles;

const BlogListPagination: FC<Props> = ({ pagination, setFilterQuery, theme }) => {
    useEffect(() => {
        setFilterQuery({ parameters: { page: initialBlogState.parameters.page } });
    }, []);

    if (!pagination?.totalItemCount) {
        return null;
    }

    const changePage = (page: number) => {
        setFilterQuery({
            parameters: {
                page,
            },
        });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Pagination
                {...styles.pagination}
                theme={theme}
                resultsCount={pagination.totalItemCount}
                currentPage={pagination.page}
                resultsPerPage={pagination.pageSize}
                resultsPerPageOptions={[]}
                onChangePage={changePage}
                onChangeResultsPerPage={() => {}}
                pageSizeCookie="BlogCategoryList-PageSize"
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(BlogListPagination as any)) as any,
    definition: {
        displayName: "Category List Pagination",
        group: "Verndale Box - Blog" as any,
        icon: "blog",
        allowedContexts: ["BlogCategoryPage" as any],
    },
};

export default widgetModule;
